import { ref } from 'vue'

/** 跨页切换动画结束、目标输入框挂载后再消费聚焦请求。 */
export const allOrdersSearchFocusRequested = ref(false)
